/* eslint-disable react/display-name */

import React, { useRef } from 'react';
import routes from '@achievable-me/tundra-wizard/routes';
import { reverse } from 'named-urls';
import ProductLayout from '$components/layout/ProductLayout';
import ScrollToTop from '$components/library/ScrollToTop';
import Seo from '$components/Seo';
import FinraSieTutoring from './FinraSieTutoring';
import FinraSeries7Tutoring from './FinraSeries7Tutoring';
import BrandonTutoring from './BrandonTutoring';
import OrionTutoring from './OrionTutoring';
import SujataTutoring from './SujataTutoring';
import WesTutoring from './WesTutoring';
import styles from './styles.scss';
import { useTrack } from '$lib/tracking';

const getTutorComponent = ({ productSlug }) => {
  switch (productSlug) {
    case 'amc-8':
    case 'amc-10':
    case 'amc-12':
      return WesTutoring;
    case 'finra-sie':
      return FinraSieTutoring;
    case 'finra-series-6':
    case 'finra-series-63':
    case 'finra-series-65':
    case 'finra-series-66':
      return BrandonTutoring;
    case 'finra-series-7':
      return FinraSeries7Tutoring;
    case 'gre':
      return OrionTutoring;
    case 'usmle-step-1':
      return SujataTutoring;
    default:
      return () => <div>No tutors currently available for this course.</div>;
  }
};

const TutoringContent = (props) => {
  const layoutRef = useRef();
  const { product } = props;
  const { slug: productSlug } = product;
  useTrack('Tutoring page | Viewed', {
    productSlug,
  });

  const TutorComponent = getTutorComponent({ productSlug });

  return (
    <ScrollToTop elementRef={layoutRef}>
      <div ref={layoutRef} className={styles.layout}>
        <Seo
          title="Tutoring"
          canonical={reverse(routes.study.tutoring, { productSlug })}
          description="Interested in a little extra help during your studies? Learn from the best - Achievable's authors are also tutors!"
        />
        <h1 className={styles.header}>Private tutoring available</h1>
        <div className={styles.subheader}>
          Interested in a little extra help during your studies? Learn from the best -
          Achievable&apos;s authors are also tutors!
        </div>
        <TutorComponent />
      </div>
    </ScrollToTop>
  );
};

const Tutoring = (props) => {
  const { currentUser, location, match } = props;

  return (
    <ProductLayout currentUser={currentUser} location={location} match={match}>
      {({ product }) => <TutoringContent product={product} />}
    </ProductLayout>
  );
};

export default Tutoring;
